import { FC } from 'react';

import { Dropdown, SearchBar } from '@components/index';
import testId from '@constants/testId';
import {
  memberFilterOptions,
  MemberType
} from '@features/group-management/constants';

interface MembersTabHeaderProps {
  totalCount: number;
  selectedCount: number;
  searchTerm: string;
  onSearch: (value: string) => void;
  selectedMemberFilter?: MemberType;
  handleMemberFilterSelection?: (dropdownValue: string) => void;
}

const MembersTabHeader: FC<MembersTabHeaderProps> = ({
  totalCount,
  selectedCount,
  searchTerm,
  onSearch,
  selectedMemberFilter,
  handleMemberFilterSelection
}) => (
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-x-10">
      <div className="flex items-center gap-x-2">
        <div className="text-xl font-medium text-content">Members</div>
        <div className="rounded-10 bg-bgBase px-2.5 text-content">
          {totalCount}
        </div>
      </div>
      <SearchBar
        placeholder="Search by name"
        value={searchTerm}
        onSearch={onSearch}
        searchBarStyle="w-96"
      />
    </div>
    <div className="flex items-center gap-x-3">
      <div className="flex items-center gap-x-1 rounded-full bg-primaryLite1 px-2 py-1.5">
        <div className="text-sm text-content">Selected</div>
        <div className="flex min-w-5 items-center justify-center rounded-full bg-primary px-1 py-0.5 text-sm leading-4 text-white">
          {selectedCount}
        </div>
      </div>
      {selectedMemberFilter && handleMemberFilterSelection && (
        <Dropdown
          dropdownId={
            testId.groupsPage.quickCollectTabHeader.addFromGroupTabHeader
          }
          currentFilter={selectedMemberFilter}
          filterOptions={memberFilterOptions}
          onSelectFilter={handleMemberFilterSelection}
          isDividerNeeded={false}
          selectedOptionClassName="hover:bg-cofeeGreyBlue2 bg-transparent text-cofeeNeutral10 !px-[8px] !py-[10px]  !font-medium !my-[0px]"
          hoverOptionClassName="hover:bg-cofeeGreyBlue2 !px-[8px] !py-[10px] !font-medium !my-[0px]"
          optionsStyle="!p-[8px] right-0 !mt-[10px] !rounded-[12px] !shadow-[0px_4px_12px_rgba(0,0,0,0.1)]"
          labelStyle="!font-medium"
        />
      )}
    </div>
  </div>
);

export default MembersTabHeader;
